<template>
  <q-header elevated class="bg-primary text-white" height-hint="98">
    <q-toolbar class="bg-white">
      <q-btn v-if="$q.screen.lt.md" flat round dense icon="menu" color="black" @click="$emit('toggle')" />

      <q-toolbar-title>
        <router-link exact to="/">
          <picture>
            <source srcset="@/assets/logo.webp" type="image/webp" />
            <img src="@/assets/logo.png" width="240" alt="logo" />
          </picture>
        </router-link>
      </q-toolbar-title>

      <q-tabs v-if="$q.screen.gt.sm">
        <q-route-tab to="/orders" label="Order Management" no-caps style="color: #000" active-class="text-primary" />
        <q-route-tab to="/users" label="User Management" no-caps style="color: #000" active-class="text-primary" />
        <q-route-tab
          to="/business"
          label="Business Management"
          no-caps
          style="color: #000"
          active-class="text-primary"
        />
        <q-route-tab to="/system" label="System Management" no-caps style="color: #000" active-class="text-primary" />
      </q-tabs>

      <div v-else class="justify-center">
        <span v-if="user" class="text-black">
          Hi,
          <strong class="text-capitalize">{{ user.name }}</strong>
        </span>

        <q-avatar class="q-ml-sm">
          <img alt="profile picture" style="height: auto" :src="profilePicture" />
        </q-avatar>
      </div>
    </q-toolbar>

    <q-tabs v-if="$q.screen.lt.md" class="bg-white" align="left">
      <q-route-tab to="/orders" label="Order Management" no-caps style="color: #000" active-class="text-primary" />
      <q-route-tab to="/users" label="User Management" no-caps style="color: #000" active-class="text-primary" />
      <q-route-tab to="/business" label="Business Management" no-caps style="color: #000" active-class="text-primary" />
      <q-route-tab to="/system" label="System Management" no-caps style="color: #000" active-class="text-primary" />
    </q-tabs>
  </q-header>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState(['user']),
    ...mapGetters(['profilePicture']),
  },
};
</script>
